// components/layouts/HeaderBackground.tsx
import Image from 'next/image';
import type { StaticImageData } from 'next/image';
import homepageBg from '@/assets/images/header-backgrounds/homepage.jpg';
import penetrationTestsBg from '@/assets/images/header-backgrounds/penetration-tests.jpg';
import vulnerabilityAssessmentsBg from '@/assets/images/header-backgrounds/vulnerability-assessments.jpg';
import managedSiemBg from '@/assets/images/header-backgrounds/managed-siem.jpg';
import threatMonitoringBg from '@/assets/images/header-backgrounds/threat-monitoring.jpg';
import complianceConsultancyBg from '@/assets/images/header-backgrounds/compliance-consultancy.jpg';
import outsourcedDpoBg from '@/assets/images/header-backgrounds/outsourced-dpo.jpg';
import cyberEssentialsBg from '@/assets/images/header-backgrounds/cyber-essentials.jpg';
import gdprTrainingBg from '@/assets/images/header-backgrounds/gdpr-training.jpg';
import penetrationTestingBg from '@/assets/images/header-backgrounds/penetration-testing.png';
import penTestGuideBg from '@/assets/images/header-backgrounds/pen-test-guide.png';
import resourcesBg from '@/assets/images/header-backgrounds/resources.jpg';
import socBg from '@/assets/images/header-backgrounds/soc.jpg';
import securityTrainingBg from '@/assets/images/header-backgrounds/security-training.jpg';
import aboutBg from '@/assets/images/header-backgrounds/about.jpg';
import partnersBg from '@/assets/images/header-backgrounds/partners.png';
import dpoForSchoolsBg from '@/assets/images/header-backgrounds/dpo-for-schools.png';
import colocationBg from '@/assets/images/header-backgrounds/colocation.png';
import infographicsBg from '@/assets/images/header-backgrounds/infographics.png';
import mdrBg from '@/assets/images/header-backgrounds/mdr.png';
import industryReportsBg from '@/assets/images/header-backgrounds/industry-reports.jpg';
import whitePapersBg from '@/assets/images/header-backgrounds/white-papers.jpg';
import webinarsBg from '@/assets/images/header-backgrounds/webinars.jpg';
import eventsBg from '@/assets/images/header-backgrounds/events.jpg';
import contactBg from '@/assets/images/header-backgrounds/contact.jpg';
import infosecBg from '@/assets/images/header-backgrounds/infosec.jpg';
import cyberSecurityAccreditationsBg from '@/assets/images/header-backgrounds/cyber-security-accreditations.jpg';

interface HeaderBackgroundProps {
  styleController: string;
}

const HeaderBackground: React.FC<HeaderBackgroundProps> = ({ styleController }) => {
  const classes = styleController.split(' ');

  const getBackgroundImage = (): StaticImageData | null => {
    for (const className of classes) {
      switch (className) {
        case 'index':
          return homepageBg;
        case 'social-engineering':
        case 'red-team':
          return penetrationTestsBg;
        case 'vulnerability-scans':
          return vulnerabilityAssessmentsBg;
        case 'managed-siem':
          return managedSiemBg;
        case 'ddos-mitigation':
          return threatMonitoringBg;
        case 'iso-27001':
        case 'iso-27002-gap-analysis':
        case 'iso-27001-gap-analysis':
        case 'iso-27001-implementation':
        case 'iso-27001-audit':
        case 'iso-soc2':
        case 'virtual_ciso':
        case 'compliance-services':
        case 'digital-forensics':
        case 'incident-response':
        case 'gdpr':
        case 'gdpr-audit':
        case 'gdpr-implementation':
        case 'gdpr-gap-analysis':
          return complianceConsultancyBg;
        case 'outsourced-dpo':
          return outsourcedDpoBg;
        case 'cyber-security-assessment':
        case 'cyber-essentials':
        case 'cyber-essentials-faqs':
          return cyberEssentialsBg;
        case 'gdpr-training':
          return gdprTrainingBg;
        case 'blog':
        case 'penetration-testing':
        case 'pen-testing':
        case 'penetration-testing-faqs':
        case 'web-application-penetration-testing':
        case 'mobile-penetration-testing':
        case 'wireless-penetration-testing':
        case 'network-penetration-testing':
        case 'cloud-penetration-testing':
        case 'enterprise-penetration-testing':
        case 'penetration_testing_network_pen_testing':
          return penetrationTestingBg;
        case 'penetration-testing-guide':
          return penTestGuideBg;
        case 'resources':
          return resourcesBg;
        case 'soc':
          return socBg;
        case 'security-training':
        case 'training-services':
          return securityTrainingBg;
        case 'about':
          return aboutBg;
        case 'partners':
          return partnersBg;
        case 'dpo-for-schools':
          return dpoForSchoolsBg;
        case 'colocation':
          return colocationBg;
        case 'infographics':
          return infographicsBg;
        case 'detection-response-services':
        case 'mdr':
          return mdrBg;
        case 'industry-reports':
        case 'industry_reports':
          return industryReportsBg;
        case 'white-papers':
        case 'white_papers':
          return whitePapersBg;
        case 'webinars':
          return webinarsBg;
        case 'events':
          return eventsBg;
        case 'contact':
        case 'quote':
        case 'purchases':
          return contactBg;
        case 'infosec-terms':
        case 'infosec':
          return infosecBg;
        case 'cyber_security_accreditations':
          return cyberSecurityAccreditationsBg;
      }
    }
    return null;
  };

  const backgroundImage = getBackgroundImage();

  if (!backgroundImage) return null;

  return (
    <div className="header-background-wrapper">
      <Image
        src={backgroundImage}
        alt=""
        priority
        quality={100}
        className="header-background"
        width={1440}
        height={580}
        style={{
          objectFit: 'cover',
          objectPosition: 'center'
        }}
      />
    </div>

  );
};

export default HeaderBackground;